import { useStore } from 'react-redux';
import type { AppState } from '../store/store';

export const useAppStore = () => useStore<AppState>();
